<head>
	<title>SBM</title>
	<meta charset="UTF-8">
	<meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
    <meta name="viewport" content="width=divice-width, initial-scale=1.0">
    	
    <!-- <script src="node_modules/chart.js/src/chart.js"></script> -->

</head>

<!-- <body id="body"> -->

	<header>
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-4">
					<div class="logo">
						<img src="assets/logo.png" alt="" />
					</div><!-- /.logo -->
				</div>
				<div style="left:auto;" class="col-md-8 col-md-push-4">

					<div class="options">
						<button style="cursor: pointer;background-color: white; margin-right: 4px;"
							(click)="op.toggle($event)" type="submit" value="Logout" class="btn">
							<i class="fas fa-info"></i></button>

						<button style="cursor: pointer;background-color: white; margin-right: 4px;"
							routerLink="/user_profile" type="submit" value="Logout" class="btn">
							<i class="far fa-user fa-lg"></i></button>
						
						<button routerLink="/logout" type="submit" value="Logout" class="btn btn-info">
							<i class="fas fa-sign-out-alt"></i> Logout</button>
						</div><!-- /.otions -->

				</div>
				<div class="col-md-4 col-md-pull-4 hide" hidden>
					<div class="search">
						<div class="search-input">
							<input type="text" name="" id="" />
							<button type="submit">
								<i class="la la-search"></i>
							</button>
						</div><!-- /.search-input -->
					</div><!-- /.search -->
				</div>
			</div>
		</div>
    </header>
    
<!-- </body> -->
<app-info #op></app-info>